import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * The email OTP page was removed at the client's request: Azure B2C verifies the email with its
 * own code when the investor sets a password. Kept only so an old /otp address (e.g. a tab left
 * open across the release) lands on the details step, or back on the email step when it carries
 * no registration code, instead of a dead page.
 */
const SelfRegistrationStep2: React.FC = () => {
  const location = useLocation();
  const hasSession = !!(location.state as { uniqueCode?: string } | null)?.uniqueCode;
  return (
    <Navigate
      to={hasSession ? '/investor/register/step3' : '/investor/register/email'}
      state={location.state}
      replace
    />
  );
};

export default SelfRegistrationStep2;
